/**
 * 径级分段统计算法
 * 算法来源：C++ CalcData() 改写为 JS（与安卓 StatUtil.java 完全一致）
 * - 从转写文本中提取连续数字（最多 4 位，遇非数字截断），与径级分段表精确匹配后累计根数
 * - 径级分段表：i∈[8,140]，8~13 全部纳入，14 及以上只取偶数
 * - 某径级方量 = 3.14 * 材长 * 该径级根数 / 40000 * 径级²（即该径级的总方量）
 * - 输出首行汇总（总根数/总方量/材长）+ 分隔线 + 各径级明细（根数/方量）
 *
 * @param {string} content 转写内容（originContent）
 * @param {number} [woodLen=1] 材长（米），非正数时默认按 1 计算
 * @returns {string} 统计文本。空内容/未匹配到任何径级时返回空字符串
 */
export function calcStat(content, woodLen) {
    const len = (woodLen == null || isNaN(woodLen) || woodLen <= 0) ? 1 : Number(woodLen)
    if (!content || !content.trim()) return ''
    const text = String(content)

    // 1. 生成径级分段表：i∈[8,140]，i<14 或 i 为偶数
    const DIA_MIN = 8
    const DIA_MAX = 140
    const size = DIA_MAX - DIA_MIN + 1
    const count = new Array(size).fill(0)
    const inMap = new Array(size).fill(false)
    for (let i = DIA_MIN; i <= DIA_MAX; i++) {
        if (i < 14 || i % 2 === 0) inMap[i - DIA_MIN] = true
    }

    // 2. 提取连续数字（最多 4 位）并按径级分段表累计根数
    let nCount = 0
    let idx = 0
    const textLen = text.length
    while (idx < textLen) {
        const code = text.charCodeAt(idx)
        if (code < 48 || code > 57) {
            idx++
            continue
        }
        // 对应 C++：tmp = Mid(i,4)，再逐字符判断连续数字（最多 4 位）
        const end = Math.min(idx + 4, textLen)
        let j = idx
        while (j < end && text.charCodeAt(j) >= 48 && text.charCodeAt(j) <= 57) {
            j++
        }
        const nVal = parseInt(text.substring(idx, j), 10)
        idx = j
        // 与径级分段表精确匹配才累计（8~13 全部，14 及以上仅偶数）
        if (nVal >= DIA_MIN && nVal <= DIA_MAX && inMap[nVal - DIA_MIN]) {
            count[nVal - DIA_MIN]++
            nCount++
        }
    }
    if (nCount === 0) return ''

    // 3. 计算方量并生成统计文本（明细按径级升序，方量为该径级总方量）
    let dFAll = 0.0
    const lines = []
    for (let d = DIA_MIN; d <= DIA_MAX; d++) {
        const c = count[d - DIA_MIN]
        if (c > 0) {
            const dF0 = 3.14 * len * c / 40000.0 * d * d
            dFAll += dF0
            lines.push(`径级[${String(d).padStart(2, '0')}]根数[${String(c).padStart(3, '0')}]方量[${dF0.toFixed(2)}]`)
        }
    }
    const summary = `总根数[${String(nCount).padStart(4, '0')}]总方量[${dFAll.toFixed(2)}]材长[${len.toFixed(2)}]`
    return summary + '\n' + '-----------------------------------\n' + lines.join('\n')
}
